// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__1Nzoa","header":"Graph_header__3nwGz","options":"Graph_options__3tERC"};